<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2022-12-29 15:21:27
 * @LastEditTime: 2023-01-11 11:19:24
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <div class="secret-group">
      <ux-tooltip v-show="showSecret" :content="$t('HT.doubleclick.copy')" placement="bottom">
        <span class="secret-content" @dblclick="copyContent">{{ secret }}</span>
      </ux-tooltip>
      <span v-show="!showSecret" class="secret-content">**********</span>
      <span class="secret-btn" @click="changeSecretContent">{{ showSecret ? $t('HT.hide') : $t('HT.stand.alone.display') }}</span>
    </div>
</template>

<script>
export default {
  props: {
    secret: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showSecret: false
    };
  },
  methods: {
    // 复制内容至剪切板
    copyContent() {
      if(this.showSecret) {
        let elInput = document.createElement('input');
        elInput.value = this.secret;
        document.body.appendChild(elInput);
        // 选择对象
        elInput.select();
        // 执行浏览器复制命令
        document.execCommand('Copy');
        elInput.remove();
        this.$uxMessage.success(this.$t('HT.copy.success'));
      }
    },
    // 切换Secret显示状态
    changeSecretContent() {
      this.showSecret = !this.showSecret;
    }
  },
};
</script>

<style lang="scss" scoped>
.secret-group {
    display: flex;
    justify-content: space-between;
}
.secret-btn {
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D7DFF;
    line-height: 20px;
}
.secret-content {
  cursor: context-menu;
}
</style>